module.exports = __webpack_public_path__ + "img/char-fo.e501ca57.svg";